import { Button } from 'antd';
import {
  BankOutlined,
  FileTextOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { Inline } from '@/shared/components/ui';
import { SectionCard } from '@/shared/components/ui';

/**
 * Three workflows a cashier reaches for outside the per-student collect flow.
 * Lives below the search results so it's discoverable without competing with
 * the primary task at the top.
 *
 *   1. End-of-day cash close   — count the drawer, generate handover slip.
 *   2. Defaulters list         — phone-in candidates.
 *   3. Daily collection report — gross / net / per-type breakdown.
 *
 * All three are existing pages; the goal here is reducing clicks from the
 * cashier's primary screen, not introducing new flows.
 */
export function CashierQuickActions() {
  const navigate = useNavigate();
  return (
    <SectionCard
      eyebrow="Cashier"
      title="When the queue clears"
      subtitle="End-of-day, follow-ups, and reporting — same screen, one click away."
    >
      <Inline gap={10} wrap>
        <Button
          icon={<BankOutlined />}
          onClick={() => navigate('/finance/cash-handover')}
        >
          End-of-day cash close
        </Button>
        <Button
          icon={<WarningOutlined />}
          onClick={() => navigate('/fee/defaulters')}
        >
          Defaulters list
        </Button>
        <Button
          icon={<FileTextOutlined />}
          onClick={() => navigate('/reports/fee-collection')}
        >
          Daily collection report
        </Button>
      </Inline>
    </SectionCard>
  );
}
